import { readableColor } from "polished"
import styled, { css } from "styled-components"

export const Container = styled.span`
  background-color: ${(props) => props.theme.colors.notifications.badge.background};
  border-radius: 4px;
  color: ${(props) => props.theme.colors.notifications.badge.text};
  padding: 0.25rem;
  text-align: center;
  min-width: 1rem;
  min-height: 1rem;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  font-size: 0.875rem;
  font-weight: 700;

  ${(props) =>
    props.size == "small" &&
    css`
      font-size: 0.9em;
      padding: 0.01rem 0.2rem;
      line-height: 1.8em;
      min-height: unset;
    `}

  ${(props) =>
    props.color &&
    css`
      background-color: ${props.color};
      color: ${readableColor(props.color)};
    `}

  ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${props.fontWeight};
    `}

  ${(props) =>
    !!props.useTheme &&
    css`
      background-color: ${props.theme.colors.primaryContrastedDarker};
    `}
`
